import { html, View } from 'rune-ts';
import klass from './ProductListSection.module.scss';
import { ProductCardViewData, ProductCardSize } from '@services/MarppleShop/features/ProductList/type';
import {
  ProductCardListView,
  ProductCardListPlugin,
} from '@services/MarppleShop/renderApp/components/cells/ProductCardList/ProductCardListView.ts';
import { SectionTitle } from '@services/MarppleShop/renderApp/components/cells/SectionTitle/SectionTitle.ts';
import { SeeMoreLinkPlugin } from '@services/MarppleShop/renderApp/components/cells/SectionTitle/plugins';
import { PostMessageNavigate } from '@services/MarppleShop/shared/app/navigate.ts';

export interface ProductListSectionProps {
  readonly section_title: {
    title: string;
    sub_title?: string;
    see_more_link: string;
    navigate?: PostMessageNavigate;
  };

  readonly products: ProductCardViewData[];

  readonly productCardListOptions?: {
    limit: number;
  };

  readonly layout_options: {
    is_mobile: boolean;
  };
}

/**
 * @todo 상품 목록 섹션에서 공통으로 사용할 수 있도록 추상화하기 (variant로 컨트롤 할 수 있도록 수정)
 */
export class ProductListSection extends View<ProductListSectionProps> {
  private readonly sectionTitle: SectionTitle;

  constructor(props: ProductListSectionProps) {
    super(props);

    this.sectionTitle = new SectionTitle({
      title_props: {
        ...this.data.section_title,
        size: this.data.layout_options.is_mobile ? 'large' : 'xLarge',
      },
      plugins: [
        new SeeMoreLinkPlugin({
          navigate: this.data.section_title.navigate,
          see_more_link: this.data.section_title.see_more_link,
          size: this.data.layout_options.is_mobile ? 'xSmall' : 'medium',
          theme: 'light',
        }),
      ],
    });
  }

  override template() {
    const is_mobile = this.data.layout_options.is_mobile;

    return html`<div class="${klass.container}">
      ${this.sectionTitle}
      <div class="${klass.products_wrapper}">
        ${this.data.products.length > 0
          ? new ProductCardListView(
              { products: this.data.products },
              {
                plugins: {
                  [ProductCardListPlugin.swiper]: {
                    enabled: is_mobile,
                    swiperOptions: {
                      autoplay: false,
                      speed: 600,
                    },
                    width: 224,
                    gap: 16,
                  },
                },
                size: is_mobile ? ProductCardSize.medium : ProductCardSize.large,
                resize_width: 600,
                is_lazy: true,
                grid: {
                  enabled: !is_mobile,
                  columns: 5,
                  column_gap: 16,
                },
                limit: 5,
              },
            )
          : ''}
      </div>
    </div>`;
  }
}
